// Metadata + copy for placeholder feature pages and static content pages.
export const PAGES = {
  "dream-number": {
    path: "/dream-number/",
    h1: "Bhutan Morning Teer Dream Number",
    title: "Bhutan Morning Teer Dream Number – Dream Meanings & Numbers",
    description:
      "Bhutan Morning Teer dream number guide. Understand common dream meanings and associated numbers. Data is updated by our team.",
    crumb: "Dream Number",
    body: [
      "The Dream Number section helps you explore the traditional numbers people associate with different dreams.",
      "Verified dream number data will be published here regularly. This section is being prepared and updated by our team.",
    ],
    comingSoon: true,
  },
  analytics: {
    path: "/analytics/",
    h1: "Bhutan Morning Teer Analytics",
    title: "Bhutan Morning Teer Analytics – Result Trends & Charts",
    description:
      "Bhutan Morning Teer analytics with result trends and frequency charts based only on verified past results.",
    crumb: "Analytics",
    body: [
      "Analytics presents charts and frequency data derived strictly from verified, previously declared results.",
      "Detailed charts will appear here once enough verified result history is available in the database.",
    ],
    comingSoon: true,
  },
  "predict-target": {
    path: "/predict-target/",
    h1: "Bhutan Morning Teer Predict Target",
    title: "Bhutan Morning Teer Predict Target – Direct, House & Ending",
    description:
      "Bhutan Morning Teer predict target information covering direct number, house and ending. Informational only.",
    crumb: "Predict Target",
    body: [
      "The Predict Target section shares informational target ideas covering Direct number, House and Ending.",
      "These are informational only and never a guarantee of any outcome. Verified content will be updated here.",
    ],
    comingSoon: true,
  },
  "teer-calendar": {
    path: "/teer-calendar/",
    h1: "Bhutan Morning Teer Calendar",
    title: "Bhutan Morning Teer Calendar – Draw Days & Timings",
    description:
      "Bhutan Morning Teer calendar with draw days and result timings for FR (10:30 AM) and SR (11:30 AM).",
    crumb: "Teer Calendar",
    body: [
      "Bhutan Morning Teer results are declared with FR at 10:30 AM and SR at 11:30 AM.",
      "A full monthly calendar with draw days and holidays will be published here.",
    ],
    comingSoon: true,
  },
  "reputed-counters": {
    path: "/reputed-counters/",
    h1: "Bhutan Morning Teer Reputed Counters",
    title: "Bhutan Morning Teer Reputed Counters – Trusted List",
    description:
      "A list of reputed Bhutan Morning Teer counters. Information will be published after verification.",
    crumb: "Reputed Counters",
    body: [
      "This section will list reputed counters with verified information only.",
      "We are collecting and verifying details before publishing them here.",
    ],
    comingSoon: true,
  },
  "morning-teer": {
    path: "/morning-teer/",
    h1: "Bhutan Morning Teer",
    title: "Bhutan Morning Teer – Result, Timings & Information",
    description:
      "Everything about Bhutan Morning Teer – result timings, how it works and where to check the latest FR and SR results.",
    crumb: "Morning Teer",
    body: [
      "Bhutan Morning Teer publishes two results each day: FR (First Round) at 10:30 AM and SR (Second Round) at 11:30 AM.",
      "Check the homepage for today's latest result and the Previous Result page for history.",
    ],
    comingSoon: false,
  },
  blog: {
    path: "/blog/",
    h1: "Bhutan Morning Teer Blog",
    title: "Bhutan Morning Teer Blog – News, Tips & Updates",
    description:
      "Bhutan Morning Teer blog with news, tips and informational updates about results and common numbers.",
    crumb: "Blog",
    body: [
      "Our blog shares informational articles, tips and updates related to Bhutan Morning Teer.",
      "New posts will be published here regularly.",
    ],
    comingSoon: true,
  },

  // Static content pages
  "about-us": {
    path: "/about-us/",
    h1: "About Us",
    title: "About Us – Bhutan Morning Teer Result",
    description:
      "About bhutanmorningteerresult.in – an informational website sharing Bhutan Morning Teer FR and SR results.",
    crumb: "About Us",
    body: [
      "bhutanmorningteerresult.in is an independent informational website that publishes Bhutan Morning Teer FR and SR results, previous results and common number information.",
      "Our goal is to provide a fast, clean and mobile-friendly way to check results. We publish results only after they are officially declared and never invent numbers.",
      "This website is not affiliated with any government or official body.",
    ],
    comingSoon: false,
  },
  "contact-us": {
    path: "/contact-us/",
    h1: "Contact Us",
    title: "Contact Us – Bhutan Morning Teer Result",
    description:
      "Contact bhutanmorningteerresult.in for feedback, corrections or queries about Bhutan Morning Teer results.",
    crumb: "Contact Us",
    body: [
      "For any feedback, corrections or queries, you can reach us by email.",
      "Email: contact@bhutanmorningteerresult.in",
      "We aim to respond to genuine queries as soon as possible.",
    ],
    comingSoon: false,
  },
  "privacy-policy": {
    path: "/privacy-policy/",
    h1: "Privacy Policy",
    title: "Privacy Policy – Bhutan Morning Teer Result",
    description:
      "Privacy policy for bhutanmorningteerresult.in describing how information is handled on our website.",
    crumb: "Privacy Policy",
    body: [
      "We respect your privacy. This website does not require you to create an account or submit personal information to view results.",
      "We may use standard analytics to understand how visitors use the site. Third-party services may collect anonymous usage data as per their own policies.",
      "By using this website you agree to this privacy policy.",
    ],
    comingSoon: false,
  },
  disclaimer: {
    path: "/disclaimer/",
    h1: "Disclaimer",
    title: "Disclaimer – Bhutan Morning Teer Result",
    description:
      "Disclaimer for bhutanmorningteerresult.in. This website is for informational purposes only.",
    crumb: "Disclaimer",
    body: [
      "This website is for informational and entertainment purposes only.",
      "We do not organise, promote or conduct any game or lottery. All results shown are for information only and are published after official declaration.",
      "Please check your local laws before participating in any activity. We are not responsible for any loss incurred.",
    ],
    comingSoon: false,
  },
  "terms-conditions": {
    path: "/terms-conditions/",
    h1: "Terms & Conditions",
    title: "Terms & Conditions – Bhutan Morning Teer Result",
    description:
      "Terms and conditions for using bhutanmorningteerresult.in.",
    crumb: "Terms & Conditions",
    body: [
      "By accessing this website you agree to use it for lawful, informational purposes only.",
      "Content may be updated or changed at any time without notice. We strive for accuracy but do not guarantee it.",
      "Continued use of the site indicates acceptance of these terms.",
    ],
    comingSoon: false,
  },
};
